import { createRouter, createWebHistory } from 'vue-router';
import App from './App.vue';
import Contenedor from './components/contenedor.vue';
import Login from './components/login_acceso.vue';
import Preguntar from './components/preguntar.vue';

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },

  // 🔥 IMPORTANTE: antes del dinámico
  {
    path: '/preguntar/:nombre?/:idFestejado?/:idInvitado?',
    name: 'Preguntar',
    component: Preguntar,
    props: route => ({
      nombre: route.params.nombre || null,
      idFestejado: Number(route.params.idFestejado) || null,
      idInvitado: Number(route.params.idInvitado) || null,
    }),
  },

  {
    path: '/:nombre?/:idFestejado?/:idInvitado?',
    name: 'App',
    component: App,
    props: route => ({
      nombre: route.params.nombre || null,
      idFestejado: Number(route.params.idFestejado) || null,
      idInvitado: Number(route.params.idInvitado) || null,
    }),
    children: [
      {
        path: '',
        component: Contenedor,
        props: route => ({
          nombre: route.params.nombre || null,
          idFestejado: Number(route.params.idFestejado) || null,
          idInvitado: Number(route.params.idInvitado) || null,
        }),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;